import React from "react";

const colors = ['#08F'];

const CompanyAvatar = ({ companyName = "", size = 40 }) => {
  const getInitials = (name) => {
    if (!name) return '?'; // fallback if name is empty

    const cleaned = name
      .replace(/^\d+\s*/, '')
      .replace(/,?\s*(LLC|Inc\.?|Ltd\.?|Corporation|Corp\.?)$/i, '')
      .trim();

    const words = cleaned.split(/\s+/);
    if (words.length >= 2) {
      return words[0][0].toUpperCase() + words[1][0].toUpperCase();
    } else if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }
    return '?';
  };

  const getColor = (name) => {
    if (!name) return '#ccc'; // fallback color
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  };

  const initials = getInitials(companyName);
  const bgColor = getColor(companyName);

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 8,
        backgroundColor: bgColor,
        color: 'white',
        fontWeight: 'bold',
        fontSize: size / 2.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'uppercase',
        userSelect: 'none',
        // margin: 'auto'
      }}
    >
      {initials}
    </div>
  );
};

export default CompanyAvatar;
